export const ORIGIN_EMAIL_NOTIFICATION = 15;
export const ORIGIN_BROWSER_NOTIFICATION = 63;



// WEBPACK FOOTER //
// ./app/request/origin/constants.js